import { ModelAnswerListPresenter } from '@/presentation/presenters/modelAnswer/modelAnswerListPresenter'
import { ModelAnswerListViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerListViewModel'

export function useModelAnswerListPresenter(
  presenter: ModelAnswerListPresenter = new ModelAnswerListPresenter(new ModelAnswerListViewModel())
) {
  return {
    modelAnswerList: presenter.modelAnswerList,
    loading: presenter.loading,
    error: presenter.error,
    hasModelAnswerInList: presenter.hasModelAnswerInList,
    fetchModelAnswerList: presenter.fetchModelAnswerList.bind(presenter)
  }
}
